export const FETCH_POSTS = "FETCH_POSTS";

export const FETCH_POST = "FETCH_POST";

export const FETCH_CATEGORIES = "FETCH_CATEGORIES";
export const FETCH_ARCHIVES = "FETCH_ARCHIVES";
export const FETCH_TAGS = "FETCH_TAGS";
export const FETCH_CONTACT = "FETCH_CONTACT";
